import { api, widgetKeyHeaders } from '../config/api';

const fetchWithRetry = async (url, options, retries = 2, backoffMs = 800, timeoutMs = 30000) => {
  for (let attempt = 0; attempt <= retries; attempt++) {
    let timeoutId = null;
    try {
      // Create AbortController for timeout
      const controller = new AbortController();
      timeoutId = setTimeout(() => controller.abort(), timeoutMs);
      
      const res = await fetch(url, {
        ...options,
        signal: controller.signal
      });
      
      if (timeoutId) clearTimeout(timeoutId);
      
      // Try to parse JSON regardless of status to surface backend fallback messages
      const data = await res.json().catch(() => ({}));
      if (res.ok || (data && data.answer)) return data;
      // For 5xx, retry
      if (res.status >= 500 && attempt < retries) {
        await new Promise(r => setTimeout(r, backoffMs * (attempt + 1)));
        continue;
      }
      // Non-retriable
      throw new Error(data?.error || `HTTP ${res.status}`);
    } catch (e) {
      if (timeoutId) clearTimeout(timeoutId);
      
      // If timeout or network error, check if backend is reachable
      if (e.name === 'AbortError' || e.message?.includes('Failed to fetch') || e.message?.includes('network')) {
        if (attempt < retries) {
          await new Promise(r => setTimeout(r, backoffMs * (attempt + 1)));
          continue;
        }
        // Final attempt failed - backend is likely down
        throw new Error('Backend server is not responding. Please check if the backend is running.');
      }
      
      if (attempt < retries) {
        await new Promise(r => setTimeout(r, backoffMs * (attempt + 1)));
        continue;
      }
      throw e;
    }
  }
};

export const apiService = {
  query: async ({ company_id_slug, session_id, query, original_question, search_query, vertical, audience, client_id, user_email, context }) => (
    fetchWithRetry(api.query(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Company-Id-Slug': company_id_slug || '',
        'X-Vertical': vertical || 'business',
      },
      body: JSON.stringify({
        company_id_slug,
        session_id,
        query,
        original_question,
        search_query,
        vertical,
        audience,
        client_id,
        user_email,
        context
      })
    })
  ),
  metrics: async (slug) => {
    const res = await fetch(api.metrics() + `?company_id_slug=${encodeURIComponent(slug)}`, {
      headers: { ...widgetKeyHeaders() },
    });
    return res.json();
  },
  companyDocs: async (slug) => {
    const res = await fetch(api.companyDocs(slug), { credentials: 'include' });
    return res.json();
  }
};


